import { gql } from "@apollo/client";

const EMAIL_AI_RESPONSE_FIELDS = gql`
  fragment EmailAiResponseFields on EmailAiResponse {
    id
    email_incoming_id
    provider
    model
    data_request
    parsed_response
    data_response
    confidence
    intent
    prompt_tokens
    completion_tokens
    total_tokens
    response_time_ms
    status
    needs_review
    attempt
    error_message
    created_at
    updated_at
  }
`;

const EMAIL_REQUEST_FIELDS = gql`
  fragment EmailRequestFields on EmailRequest {
    id
    email_incoming_id
    ee_id
    stand_id
    equipment_id
    flooring_id
    exhibition_name
    company_name
    stand_number
    action
    item_name
    item_qty
    item_notes
    confidence
    status
    ai_data
    processed_by_id
    processed_at
    notes
    created_at
    updated_at
    relExhibitionEvent {
      id
      title
      organizer_id
      exhibition_type_id
      organizer {
        id
        title
      }
      exhibitionType {
        id
        title
      }
    }
    relStand {
      id
      stand_number
      company_name
    }
    relEquipment {
      id
      group_id
      title
      color
    }
    relFlooring {
      id
      title
      color
    }
  }
`;

const EMAIL_INCOMING_FIELDS = gql`
  fragment EmailIncomingFields on EmailIncoming {
    id
    email_channel_id
    message_id
    message_uid
    subject
    from_email
    from_name
    body_html
    body_clean
    header_meta {
      cc
      to
      from
      sent_at
      subject
      priority
    }
    intent
    status
    parse_error
    parsed_data
    used_token
    received_at
    parsed_at
    created_at
    updated_at
    getAiResponseCount {
      total
      processing
    }
    relEmailChannel {
      id
      title
    }
    relEmailAiResponses {
      ...EmailAiResponseFields
    }
    relEmailRequests {
      ...EmailRequestFields
    }
  }
  ${EMAIL_AI_RESPONSE_FIELDS}
  ${EMAIL_REQUEST_FIELDS}
`;

export const GET_EMAIL_INCOMINGS = gql`
  query GetEmailIncomings(
    $first: Int!
    $page: Int
    $text: String
    $where: QueryEmailIncomingsWhereWhereConditions
    $orderBy: [QueryEmailIncomingsOrderByOrderByClause!]
  ) {
    emailIncomings(first: $first, page: $page, text: $text, where: $where, orderBy: $orderBy) {
      paginatorInfo {
        total
        count
        currentPage
        perPage
        lastPage
      }
      data {
        ...EmailIncomingFields
      }
    }
  }
  ${EMAIL_INCOMING_FIELDS}
`;

export const GET_EMAIL_REQUESTS = gql`
  query GetEmailRequests(
    $first: Int!
    $page: Int
    $text: String
    $where: QueryEmailRequestsWhereWhereConditions
    $orderBy: [QueryEmailRequestsOrderByOrderByClause!]
  ) {
    emailRequests(first: $first, page: $page, text: $text, where: $where, orderBy: $orderBy) {
      paginatorInfo {
        total
        count
        currentPage
        perPage
        lastPage
      }
      data {
        ...EmailRequestFields
      }
    }
  }
  ${EMAIL_REQUEST_FIELDS}
`;

export const GET_EMAIL_INCOMING = gql`
  query GetEmailIncoming($id: ID!) {
    emailIncoming(id: $id) {
      ...EmailIncomingFields
    }
  }
  ${EMAIL_INCOMING_FIELDS}
`;

export const GET_EMAIL_REQUEST = gql`
  query GetEmailRequest($id: ID!) {
    emailRequest(id: $id) {
      ...EmailRequestFields
    }
  }
  ${EMAIL_REQUEST_FIELDS}
`;
